import {action, makeAutoObservable} from "mobx"
import CategoriesApi, {CategoriesCompareGet} from "../../api/CategoriesApi"
import {OzonCategoryOption} from "../../components/AsyncCategorySelection"

const prefix = "CategoryCompare"
export default class CategoryCompare {
    private _is_export: boolean

    set is_collapsed(value: boolean) {
        window.localStorage.setItem(prefix + this.wa_category_id, JSON.stringify(value))
        this._is_collapsed = value
    }

    get is_collapsed(): boolean {
        return this._is_collapsed
    }

    wa_category_id: number
    wa_category_name: string
    ozon_cat_id: number | undefined
    ozon_cat_name: string | undefined
    children: CategoryCompare[] = []
    private _is_collapsed: boolean

    constructor(category: CategoriesCompareGet) {
        this._count = +category.sku_count
        this._url = category.url
        this.wa_category_id = +category.id
        this.wa_category_name = category.name
        this._is_collapsed = category.is_collapsed
        this._is_export = category.is_export
        const collapsed = window.localStorage.getItem(prefix + this.wa_category_id)
        if (collapsed) {
            this._is_collapsed = JSON.parse(collapsed)
        }
        makeAutoObservable(this)
        for (const child of category.categories) {
            this.children.push(new CategoryCompare(child))
        }
        if (category.ozonCategory) {
            this.setDefaultOption(category.ozonCategory)
        }
    }

    get lastCategory(): CategoryCompare {
        if (!this._is_collapsed && this.children.length === 1) {
            return this.children[0]
        } else {
            return this
        }
    }

    private _count: number

    get count(): number {
        return this._count
    }

    private _url: string

    get url(): string {
        return this._url
    }

    private _optionValue: { value: string; label: string } | undefined

    get optionValue(): { value: string; label: string } | undefined {
        return this._optionValue
    }

    private _defaultOptions: false | OzonCategoryOption[] = false

    get defaultOptions(): any {
        return this._defaultOptions
    }

    set defaultOptions(value: any) {
        this._defaultOptions = value
    }

    setOption(option: OzonCategoryOption) {
        if (this.children.length > 0) {
            this.children.forEach((child) => child.setOption(option))
        }
        this._optionValue = option
        if (this._is_export) {
            this.ozon_cat_id = +option.value
            // CategoriesApi.savePair(this.ozon_cat_id, this.wa_category_id).then((result) => {
            //     console.log(result)
            // })
        }
    }

    delete() {
        // CategoriesApi.deletePairWith(this.wa_category_id).then((result) => {
            this._optionValue = undefined
        // })
    }

    setDefaultOption(option: { value: string, label: string }) {
        this._optionValue = option
    }

    getDefaultOptions() {
        this.getOptions("").then(action("defaultOptionsLoaded", (result) => {
            this.defaultOptions = result
        }))
    }

    getOptions = (inputValue: string): Promise<ReadonlyArray<OzonCategoryOption>> => {
        return CategoriesApi.searchCategory(inputValue)
            .then(action("categoriesSearchLoaded", (result) => {
                const data = result.data.data
                const options = []
                if (this.optionValue) {
                    options.push(this.optionValue)
                }
                for (const datum of data) {
                    options.push({
                        label: datum.full_name,
                        value: datum.category_id
                    })
                }
                return options
            }))
    }

}